import { ISuggestItemDataClassSchema } from '../../repositories/geo-suggest/entities/entities/SuggestItemDataClassSchema';
import { ESuggestType, ILine, IUndergroundSuggest, TBoundedBy } from '@cian/geosuggest-widget/es/types';

export const mapUndergrounds = (undergrounds: ISuggestItemDataClassSchema[]): IUndergroundSuggest[] => {
  return undergrounds.map(underground => ({
    regionId: underground.regionId as number,
    fullName: underground.fullName,
    id: underground.id,
    lines: underground.lines as ILine[],
    releaseYear: underground.releaseYear,
    underConstruction: underground.underConstruction,
    matches: underground.matches as TBoundedBy,
    name: underground.name,
    type: (underground.type as unknown) as ESuggestType.underground,
  }));
};
